import React from 'react';
import styles from '../asset/scoreStatisticBoard.module.scss';

const DotIndicator = ({ count = 4, color = '#4f48ff', size = 4 }) => (
    <div className={styles.dotIndicator}>
        {Array.from({ length: count }).map((_, index) => (
            <div
                key={index}
                className={styles.dot}
                style={{ backgroundColor: color, width: size, height: size }}
            />
        ))}
    </div>
);

export default DotIndicator;
